import { createStore } from 'stimulus-store'

/**
 * Store for all projects in the organization
 *
 * Populated by the projects supplier controller (autoLoad) on page load and
 * shared across components that need the org's project list. On admin-facing
 * pages this holds the full org-wide project list; for non-admins it holds the
 * user's member-scoped projects.
 *
 * Each entry is a project object as returned by the Projects JSON API
 * (e.g. { id, name, description, locales[], ... }), optionally carrying a
 * batched member count for list rendering.
 */
export const allProjectsStore = createStore({
    name: 'allProjectsStore',
    type: Array,
    initialValue: []
})
